import RestService from './RestService';
import { buildQueryString } from '../utils/helpers';

export default class Subjects extends RestService {
    constructor(parentService, parentId) {
        if (parentService && parentId) {
            super(`${parentService.baseUrl}/${parentId}/trainings`);
        } else super('/trainings');
    }

    myTrainings(params) {
        return this.get(`${this.baseUrl}/my-trainings?${buildQueryString(params)}`);
    }

    myTraining(id, params) {
        return this.get(
            `${this.baseUrl}/my-training/${id}?${buildQueryString(params)}`
        );
    }

    idByEvent(eventId) {
        return this.get(`${this.baseUrl}/my-trainings/IDbyEvent/${eventId}`);
    }

    downloadCertificate(trainingId, params, options) {
        return this.get(`/download/certificate/${trainingId}`, params, options);
    }
}
